var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "dynamic-tabs-nav",
      attrs: { "aria-labelled-by": "dynamic-tabs-nav-label" }
    },
    [
      _c(
        "ul",
        { staticClass: "dynamic-tabs-nav-items" },
        [
          _c("li", { staticClass: "dynamic-tabs-nav-item is-label" }, [
            _c("span", { attrs: { id: "dynamic-tabs-nav-label" } }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.links, function(link, index) {
            return _c(
              "li",
              {
                key: link.handle + index,
                staticClass: "dynamic-tabs-nav-item",
                class: {
                  "is-active": link.handle === _vm.activeLink
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: link.url },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleClick(link.handle)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(link.title) + "\n      ")]
                )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectModel,
              expression: "selectModel"
            }
          ],
          staticClass: "dynamic-tabs-nav-select",
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selectModel = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            }
          }
        },
        _vm._l(_vm.links, function(link, index) {
          return _c(
            "option",
            { key: link.url + index, domProps: { value: link.handle } },
            [_vm._v("\n      " + _vm._s(link.title) + "\n    ")]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }